/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformanceMetric } from './PerformanceMetric';
import {
  PerformanceMetricFromJSON,
  PerformanceMetricFromJSONTyped,
  PerformanceMetricToJSON,
} from './PerformanceMetric';

/**
 *
 * @export
 * @interface PaginatedPerformanceMetricList
 */
export interface PaginatedPerformanceMetricList {
  /**
   *
   * @type {number}
   * @memberof PaginatedPerformanceMetricList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerformanceMetricList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerformanceMetricList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<PerformanceMetric>}
   * @memberof PaginatedPerformanceMetricList
   */
  results: Array<PerformanceMetric>;
}

/**
 * Check if a given object implements the PaginatedPerformanceMetricList interface.
 */
export function instanceOfPaginatedPerformanceMetricList(value: object): value is PaginatedPerformanceMetricList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedPerformanceMetricListFromJSON(json: any): PaginatedPerformanceMetricList {
  return PaginatedPerformanceMetricListFromJSONTyped(json, false);
}

export function PaginatedPerformanceMetricListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedPerformanceMetricList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(PerformanceMetricFromJSON),
  };
}

export function PaginatedPerformanceMetricListToJSON(value?: PaginatedPerformanceMetricList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(PerformanceMetricToJSON),
  };
}
